var React = require('react');

function WentOffline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.75 12v1h-2v-1H3.647A1.65 1.65 0 0 1 2 10.353V2.647C2 1.738 2.738 1 3.647 1h12.706C17.262 1 18 1.738 18 2.647v7.706c0 .909-.738 1.647-1.647 1.647H6.75zM4 3v7h12V3H4zm15.25 13.5l-3.5 3.5v-7l3.5 3.5zm-14.557 0L2.75 14.557 3.807 13.5l1.943 1.943L7.693 13.5l1.057 1.057L6.807 16.5l1.943 1.943L7.693 19.5 5.75 17.557 3.807 19.5 2.75 18.443 4.693 16.5zm8.057-1h2v2h-2v-2zm-3 0h2v2h-2v-2zM8 7h4a.5.5 0 1 1 0 1H8a.5.5 0 1 1 0-1zM5 4h10v2H5V4z","fill":"currentColor"}));
}

WentOffline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = WentOffline;

WentOffline.default = WentOffline;
